import { render, staticRenderFns } from "./settingDelivery.vue?vue&type=template&id=13102c57&scoped=true"
import script from "./settingDelivery.vue?vue&type=script&lang=js"
export * from "./settingDelivery.vue?vue&type=script&lang=js"
import style0 from "./settingDelivery.vue?vue&type=style&index=0&id=13102c57&prod&lang=less&scoped=true"
import style1 from "./settingDelivery.vue?vue&type=style&index=1&id=13102c57&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13102c57",
  null
  
)

export default component.exports